import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as levenshtein from 'fast-levenshtein';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-district-representative-bussiness',
  // standalone: true,
  // imports: [],
  templateUrl: './district-representative-bussiness.component.html',
  styleUrl: './district-representative-bussiness.component.scss'
})
export class DistrictRepresentativeBussinessComponent {

  datewisedata;
  today = new Date();
  startdate = '';
  enddate = '';
  datewiselist = [];
  tempdata = [];
  district: any;
  appliedFilters: any = {};

  isLoading: boolean = false;
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
    // { name: 'मुदत ठेव (पंचवार्षिक वर्गणीदार)', isVisible: false },
    // { name: 'रामसेवक ग्रंथयात्री', isVisible: false },
    // { name: 'लोकनेता गंथयात्री वार्षिक', isVisible: false },
    // { name: 'लोकमान्य ग्रंथयात्री वार्षिक वर्गणी', isVisible: false },
    // { name: 'हिंदुत्व ग्रंथयात्री', isVisible: false },
    // { name: 'हिंदुत्व 1', isVisible: false },
    // { name: 'हिंदुत्व 2', isVisible: false },
    // { name: 'आजीव', isVisible: false },
    // { name: 'अनामत', isVisible: false },
  ];
  totalth = 0;
  finalData = [];
  state: any;
  country: any;

  constructor(
    private dialogref: MatDialogRef<DistrictRepresentativeBussinessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    debugger
    this.isLoading = true;
    this.district = this.data.district
    this.datewisedata = this.data['data'];
    console.log(this.datewisedata, "first data")
    // this.datewisedata = this.datewisedata.filter((item: any) => {
    //   return item.district_name === this.district
    // })

    console.log(this.datewisedata, "statewise")
    this.startdate = this.data['startDate'];
    this.enddate = this.data['endDate'];
    // console.log(formatDate(new Date(), 'MMMM', 'en-IN', 'GMT+0530'));

    this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);

    let data = this.uniqueData(this.datewisedata, (a) => a.subscription_type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
        // if (
        //   data[i]['Subscription_Type'] !== 'हितचिंतक सप्रेम भेट' ||
        //   data[i]['Subscription_Type'] !== 'सप्रेम भेट - संपादकीय विभाग' ||
        //   data[i]['Subscription_Type'] !== 'जाहिरात स. भेट' ||
        //   data[i]['Subscription_Type'] !== 'संघ परिवार सप्रेम भेट' ||
        //   data[i]['Subscription_Type'] !== 'वर्गणी सप्रेम भेट'
        // ) {
        this.subTypesName.push({
          name: data[i]['subscription_type'],
          isVisible: true,
        });
        // }
      }
    }

    // console.log(this.subTypesName);
    // this.totalth = this.subTypesName.length * 3 + 4;

    this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 4;

    // this.getDateORrepwiselist();
    this.setData();
  }

  getDistrictTotal(districtData: any[], key: string): number {
    return districtData.reduce((sum, office) => sum + (office[key] || 0), 0);
  }

  getDistrictSubtypeTotal(districtData: any[], subName: string, suffix: string): number {
    return districtData.reduce((sum, office) => sum + (office.subtype_totals?.[this.getKey(subName) + suffix] || 0), 0);
  }

  getTotal(data: any[], key: string): number {
    return data.reduce((sum, country) =>
      sum + country.datewiseData.reduce((s, state) =>
        s + state.datewiseData.reduce((dSum, district) =>
          dSum + district.datewiseData.reduce((oSum, office) => oSum + (office[key] || 0), 0), 0), 0), 0);
  }

  getTotalSubtype(data: any[], subName: string, suffix: string): number {
    return data.reduce((sum, country) =>
      sum + country.datewiseData.reduce((s, state) =>
        s + state.datewiseData.reduce((dSum, district) =>
          dSum + district.datewiseData.reduce((oSum, office) =>
            oSum + (office.subtype_totals?.[this.getKey(subName) + suffix] || 0), 0), 0), 0), 0);
  }

  soundex(s: string): string {
    return s
      .toUpperCase()
      .replace(/[^A-Z]/g, "") // Remove non-alphabet characters
      .split("")
      .map((char) => {
        if ("AEIOUHWY".includes(char)) return "0";
        if ("BFPV".includes(char)) return "1";
        if ("CGJKQSXZ".includes(char)) return "2";
        if ("DT".includes(char)) return "3";
        if ("L".includes(char)) return "4";
        if ("MN".includes(char)) return "5";
        if ("R".includes(char)) return "6";
        return char;
      })
      .join("")
      .replace(/0/g, "");
  }

  setData() {
    let index = 0;
    const countryMap = this.datewisedata.reduce((acc, record) => {
      if (!acc[record.country]) acc[record.country] = {};
      if (!acc[record.country][record.state]) acc[record.country][record.state] = {};
      if (!acc[record.country][record.state][record.district_name]) acc[record.country][record.state][record.district_name] = [];

      acc[record.country][record.state][record.district_name].push(record);
      return acc;
    }, {});

    console.log(countryMap);
    let finalTotal: any = {};

    this.subTypesName.forEach((b: any, i) => {
      if (b.isVisible) {
        let name = this.getKey(b.name);
        finalTotal[name + '_एकूण'] = 0;
        finalTotal[name + '_नवीन'] = 0;
        finalTotal[name + '_नूतनीकरण'] = 0;
        if (i === 0) {
          finalTotal['name'] = 'एकूण';
          finalTotal['एकूण'] = 0;
          finalTotal['नवीन'] = 0;
          finalTotal['नूतनीकरण'] = 0;
        }
      }
    });

    Object.entries(countryMap).forEach(([country, states]) => {
      Object.entries(states).forEach(([state, districts]) => {
        Object.entries(districts).forEach(([district, records]) => {

          let datewiseData: any = records;
          let totalData: any = {};

          this.subTypesName.forEach((b: any, i) => {
            if (b.isVisible) {
              let name = this.getKey(b.name);
              totalData[name + '_एकूण'] = 0;
              totalData[name + '_नवीन'] = 0;
              totalData[name + '_नूतनीकरण'] = 0;

              if (i === 0) {
                totalData['एकूण'] = 0;
                totalData['नवीन'] = 0;
                totalData['नूतनीकरण'] = 0;
              }
            }
          });

          let representativeMap: Map<string, { total_amt: number; new_count: number; renew_count: number,taluka:any }> = new Map();

          datewiseData.forEach((a: any) => {
            let name = this.getKey(a.subscription_type);
            totalData['crdt_voucher_date'] = a.crdt_voucher_date;

            let repKey = a.rep_name || "Unknown";

            // if (![...representativeMap.keys()].some(existingKey => levenshtein.get(existingKey, repKey) <= 2)) {
            //   representativeMap.set(repKey, {
            //         total_amt: 0,
            //         new_count: 0,
            //         renew_count: 0
            //     });
            //     let repData = representativeMap.get(repKey);
            //     this.subTypesName.forEach((b: any, i) => {
            //       if (b.isVisible) {
            //           let name = this.getKey(b.name);
            //           repData[name + '_एकूण'] = 0;
            //           repData[name + '_नवीन'] = 0;
            //           repData[name + '_नूतनीकरण'] = 0;

            //           if (i === 0) {
            //             repData['एकूण'] = 0;
            //               repData['नवीन'] = 0;
            //               repData['नूतनीकरण'] = 0;
            //           }
            //       }
            //   });
            // }

            // let repData = representativeMap.get(repKey);

            // Find a close match if it exists
            let existingKey = [...representativeMap.keys()].find(existingKey => levenshtein.get(existingKey, repKey) <= 2);

            if (!existingKey) {
              // No close match found, set a new entry
              representativeMap.set(repKey, {
                total_amt: 0,
                new_count: 0,
                renew_count: 0,
                taluka: a.rep_taluka || '',
              });
              existingKey = repKey; // Use the newly added key
            }

            // Now, retrieve the data using the correct key
            let repData = representativeMap.get(existingKey);

            this.subTypesName.forEach((b: any, i) => {
              if (b.isVisible) {
                let name = this.getKey(b.name);
                repData![name + '_एकूण'] = repData![name + '_एकूण'] || 0;
                repData![name + '_नवीन'] = repData![name + '_नवीन'] || 0;
                repData![name + '_नूतनीकरण'] = repData![name + '_नूतनीकरण'] || 0;

                if (i === 0) {
                  repData!['एकूण'] = repData!['एकूण'] || 0;
                  repData!['नवीन'] = repData!['नवीन'] || 0;
                  repData!['नूतनीकरण'] = repData!['नूतनीकरण'] || 0;
                }
              }
            });
            repData!.taluka = a.rep_taluka;
            repData!.total_amt += parseInt(a.total_amt);
            repData!.new_count += a.rcpt_type === 'New' ? 1 : 0;
            repData!.renew_count += a.rcpt_type === 'Renew' ? 1 : 0;

            repData[name + '_एकूण'] += parseInt(a.total_amt);
            repData[name + '_नवीन'] += (a.rcpt_type === 'New' ? 1 : 0);
            repData[name + '_नूतनीकरण'] += (a.rcpt_type === 'Renew' ? 1 : 0);

            repData['एकूण'] += parseInt(a.total_amt);
            repData['नवीन'] += (a.rcpt_type === 'New' ? 1 : 0);
            repData['नूतनीकरण'] += (a.rcpt_type === 'Renew' ? 1 : 0);

            totalData[name + '_एकूण'] = (totalData[name + '_एकूण'] || 0) + parseInt(a.total_amt);
            finalTotal[name + '_एकूण'] = (finalTotal[name + '_एकूण'] || 0) + parseInt(a.total_amt);

            totalData[name + '_नवीन'] = (totalData[name + '_नवीन'] || 0) + (a.rcpt_type === 'New' ? 1 : 0);
            finalTotal[name + '_नवीन'] = (finalTotal[name + '_नवीन'] || 0) + (a.rcpt_type === 'New' ? 1 : 0);

            totalData[name + '_नूतनीकरण'] = (totalData[name + '_नूतनीकरण'] || 0) + (a.rcpt_type === 'Renew' ? 1 : 0);
            finalTotal[name + '_नूतनीकरण'] = (finalTotal[name + '_नूतनीकरण'] || 0) + (a.rcpt_type === 'Renew' ? 1 : 0);

            totalData['एकूण'] = (totalData['एकूण'] || 0) + parseInt(a.total_amt);
            finalTotal['एकूण'] = (finalTotal['एकूण'] || 0) + parseInt(a.total_amt);

            totalData['नवीन'] = (totalData['नवीन'] || 0) + (a.rcpt_type === 'New' ? 1 : 0);
            finalTotal['नवीन'] = (finalTotal['नवीन'] || 0) + (a.rcpt_type === 'New' ? 1 : 0);

            totalData['नूतनीकरण'] = (totalData['नूतनीकरण'] || 0) + (a.rcpt_type === 'Renew' ? 1 : 0);
            finalTotal['नूतनीकरण'] = (finalTotal['नूतनीकरण'] || 0) + (a.rcpt_type === 'Renew' ? 1 : 0);

            totalData['taluka'] = a.taluka;
            totalData['state'] = a.state;
            totalData['country'] = a.country;
            totalData['district_name'] = a.district_name;
            totalData['rep_taluka'] = a.rep_taluka;
            // repData['taluka'] = a.taluka_name;

            // totalData['taluka'] = a.rep_taluka || a.taluka_name || 'Unknown';
            
          });
          

          totalData['representatives'] = Object.fromEntries(representativeMap);

          // Ensure district contains structured representative data
          districts[district] = {
            records: datewiseData,
            finalData: totalData
          };
        });
      });
    });

    let finalDataArray = Object.entries(countryMap).map(([key, value]) => ({
      key,
      value,
    }));

    finalDataArray.push({ key: 'finalData', value: finalTotal });
    console.log(finalDataArray);
    this.finalData = finalDataArray;
    this.isLoading = false;
  }



  getKey(name) {
    return name.replaceAll(' ', '_');
  }

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section1');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


  //Main Report Method Use in all Printing Page
  show = false
  // printPage() {
  //   this.show = true
  //   const printContent = document.getElementById('print-section1')?.outerHTML;
  //   if (!printContent) {
  //     console.error("Print section not found!");
  //     return;
  //   }

  //   const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  //   if (printWindow) {
  //     printWindow.document.open();
  //     printWindow.document.write(`
  //            <html>
  //                <head>
  //                    <title>Print Report</title>
  //                    <style>
  //                        @media print {
  //                            @page { 
  //                                size: A3 landscape; /* Set A3 size with landscape mode */
  //                                margin: 5mm; /* Adjust margins */
  //                            }
  //                            body { 
  //                                font-family: Arial, sans-serif; 
  //                                font-size: 15px; /* Adjust font size */
  //                                margin: 0; 
  //                                padding: 5mm; 
  //                                line-height: 1.2; 
  //                            }
  //                            table { 
  //                                width: 100%; 
  //                                height: 100%;
  //                                border-collapse: collapse; 
  //                                table-layout: fixed; /* Prevent column expansion */
  //                                page-break-inside: avoid; /* Avoid breaking the table */
  //                            }
  //                            th, td { 
  //                                padding: 1px; 
  //                                border: 1px solid black; 
  //                                text-align: center; 
  //                                font-size: 12px; /* Adjusted font size */
  //                                line-height: 1.2; 
  //                            }
  //                            .noPrint { 
  //                                display: none; /* Hide print button */
  //                            }
  //                        }
  //                    </style>
  //                </head>
  //                <body>
  //                    <div id="print-section1">
  //                        ${printContent}
  //                    </div>
  //                    <script>
  //                        window.onload = function() { 
  //                            window.print(); 
  //                            setTimeout(() => { window.close(); }, 500);
  //                        };
  //                    </script>
  //                </body>
  //            </html>
  //        `);
  //     printWindow.document.close();
  //   } else {
  //     console.error("Failed to open print window.");
  //   }
  // }


  printPage() {
  this.show = true;

  const printContent = document.getElementById('print-section1')?.innerHTML;
  if (!printContent) {
    console.error("Print section not found!");
    return;
  }

  const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page {
                size: A3 landscape;
                margin: 10mm;
              }

              body {
                font-family: Arial, sans-serif;
                font-size: 13px;
                margin: 0;
                padding: 0;
              }

              table {
                width: 100%;
                border-collapse: collapse;
                page-break-inside: avoid;
              }

              th, td {
                border: 1px solid black;
                padding: 3px 5px;
                font-size: 14px;
                
              }

              tr {
                page-break-inside: avoid;
                page-break-after: auto;
              }

              .noPrint {
                display: none;
              }
            }

            body {
              font-family: Arial, sans-serif;
              font-size: 13px;
            }

            table {
              width: 100%;
              border-collapse: collapse;
            }

            th, td {
              border: 1px solid black;
              padding: 3px 5px;
              text-align: center;
            }
          </style>
        </head>
        <body>
          <div>
            ${printContent}
          </div>
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => { window.close(); }, 500);
            };
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  } else {
    console.error("Failed to open print window.");
  }
}

}
